import { render } from "./SubCategories.vue?vue&type=template&id=1c3e6412"
import script from "./SubCategories.vue?vue&type=script&lang=js"
export * from "./SubCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__